export default __webpack_public_path__ + "static/media/Golden Visa.7412a9e5.jpg";